import { Flex, Badge, Text} from "@chakra-ui/react";
import { getInitials } from "../../utils";

interface AvatarProps {
    name: string;
}
const Avatar = ({ name } :AvatarProps ) => {
    let initials = getInitials(name);
    return(
        <Flex align="center" gridGap="2">
          <Badge
            fontSize="1rem"
            minWidth="35px"
            minHeight="35px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            colorScheme="yellow"
            color="gray.800"
          >
            {initials ?? "-"}
          </Badge>
          <Text>{name}</Text>
        </Flex>
    )
}


export { Avatar };